
import { mapGetters } from 'vuex';
export default {
    components: {
        breadcrumbs: () => import('../../../components/pages/breadcrumbs.vue'),
        cartTable: () => import('../../../components/pages/cart-table.vue')
    },
	computed: {
		...mapGetters({
			getterTranslates 	: 'getterTranslates',
			getterStoreLang	 	: 'getterStoreLang'
        })
    }
};
